import { TutorialSequence } from './tutorial-sequence';

export class Tutorials {
  constructor() {
    const overblikSequence = new TutorialSequence(Tutorials.sequenceIdOverblik, 2);
    overblikSequence.tooltips[0].lockScrollbar = true;

    const ansoegningerSequence = new TutorialSequence(Tutorials.sequenceIdAnsoegninger, 1);
    ansoegningerSequence.tooltips[0].lockScrollbar = true;

    const foersteKravSequence = new TutorialSequence(Tutorials.sequenceIdFoerstekrav, 3);
    foersteKravSequence.tooltips[0].lockScrollbar = true;
    foersteKravSequence.tooltips[1].lockScrollbar = true;

    this.sequences.push(overblikSequence, ansoegningerSequence, foersteKravSequence);
  }

  static sequenceIdOverblik = 'Overblik';
  static sequenceIdAnsoegninger = 'Ansoegninger';
  static sequenceIdFoerstekrav = 'Foerstekrav';
  sequences: TutorialSequence[] = [];
}
